import type {PostSortingMetric} from '@Components/social-media/social-media.types';
import {SocialPlatform} from '@Components/social-media/social-media.types';
import type {SocialMediaGridRequestThunkParams} from '@Components/social-media/social-media-thunk';
import type {SocialAccount} from '@Components/social-media/account.vo';
import {AccountState} from '@Components/social-media/account.vo';
import type {SocialPost} from '@Components/social-media/post.vo';
import {PostState, PrivacySettings} from '@Components/social-media/post.vo';
import type React from 'react';

export const NUM_SKELETONS_TO_SHOW = 4;
export const SOCIAL_POSTS_GRID_CONTAINER_ID = 'js-social-posts-grid';
export const LAZY_LOAD_DEBOUNCE_MS = 20;
export const BEFORE_UNLOAD_EVENT = 'beforeunload';
export const CACHE_KEY_FOR_SCHEDULING = 'emc_schedule_v1';

export interface BuildGridRequestParamsOpts {
  offset: number;
  sortPostsBy: PostSortingMetric;
  getSharedInTeam: boolean;
  limit: number;
  getDeleted: boolean;
}

export const buildGridRequestParams = (opts: BuildGridRequestParamsOpts): SocialMediaGridRequestThunkParams => {
  return {
    limit: opts.limit,
    offset: opts.offset,
    getDeleted: opts.getDeleted,
    sortPostsBy: opts.sortPostsBy,
    getSharedInTeam: opts.getSharedInTeam,
  };
};

export const isGridScrolledToBottom = (containerId: string): boolean => {
  const tar = document.getElementById(containerId);
  if (tar) {
    return tar.getBoundingClientRect().bottom <= window.innerHeight;
  }
  return false;
};

export const startSocialMediaPublishing = (posterHashedId?: string, callback: () => void = (): void => {}): void => {
  if (posterHashedId) {
    window.location.href = window.PMW.util.site_url(`socialmedia/post/design/${posterHashedId}`);
  } else {
    window.location.href = window.PMW.util.site_url(`socialmedia/post/`);
  }

  callback();
};

export const hideUnnecessaryMyStuffElements = (): void => {
  document.querySelector('.js-padded-top-bar')?.classList.add('_hidden');
};

export const unhideUnnecessaryMyStuffElements = (): void => {
  document.querySelector('.js-padded-top-bar')?.classList.remove('_hidden');
};

export const seekAndPauseAutoplayVideo = (e: React.SyntheticEvent<HTMLVideoElement>, seekTimestamp: number): void => {
  const video = e.target as HTMLVideoElement;
  video.pause();
  video.currentTime = seekTimestamp;
};

export const getDummySocialPostForSkeleton = (): SocialPost => {
  return {
    id: '0',
    userId: 0,
    privacySetting: PrivacySettings.PUBLIC,
    state: PostState.PUBLISHED,
    publishingParams: {},
    accounts: [getDummySocialAccountForSkeleton()],
    isDeleted: false,
    isVideo: false,
    designs: [{posterHashedId: '0', pageHashedId: '0'}],
    isSharedInTeam: false,
  } as SocialPost;
};

export const getDummySocialAccountForSkeleton = (): SocialAccount => {
  return {
    id: 0,
    type: SocialPlatform.FACEBOOK,
    name: '',
    displayURL: '',
    state: AccountState.CONNECTED,
  } as SocialAccount;
};
